import { Outlet } from 'react-router-dom';
import BlogsNav from '@composites/Headers/BlogsNav';
import BlogsFooter from '@composites/Footers/BlogsFooter';
import { ACCOUNT_ID, usePublicBlogsByAccount } from '@utils/apiHooks';

const BlogsLayout = () => {
  const { data: blogsData } = usePublicBlogsByAccount({
    accountId: ACCOUNT_ID,
  });
  const blogs = blogsData?.data || [];

  return (
    <>
      <BlogsNav blogs={blogs} />
      <Outlet />
      <BlogsFooter blogs={blogs} />
    </>
  );
};

export default BlogsLayout;
